export const ZONE_ENTITY = "zone";
export const LOG_ENTITY = "log";
export const ARCHIVE_ENTITY = "archive";
export const LICENCE_ENTITY = "licence";
export const PREF_ENTITY = "preferences";
export const USER_ENTITY = "users";
export const TARGET_ENTITY = "targets";
